"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatetimeInput = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const public_1 = require("../../common/public");
const DatetimeInputContext_1 = require("./context/DatetimeInputContext");
const getDateWithOffset_1 = require("./helpers/getDateWithOffset");
const Dropdown_1 = require("../Dropdown");
const helpers_1 = require("../../helpers");
const useControlState_1 = require("../helpers/useControlState");
const DatetimeSelector_1 = require("./components/DatetimeSelector/DatetimeSelector");
const constants_1 = require("./helpers/constants");
const renderer_1 = require("./renderer");
const PopoverBody = styled_components_1.default.div `
    padding: 16px;
    box-sizing: border-box;
    max-height: 100%;
    overflow-y: auto;
`;
exports.DatetimeInput = (0, helpers_1.createUIElement)('DatetimeInput', (_a, ref) => {
    var { className, disabled, value, onChange, size, error, withTime = false, rightSectionRenderer, is12Hours = false, startDatetime = new Date(0), placeholder, endDatetime = new Date(9999, 11, 31), isDisabledDate, onDateError, texts, highlightDates = [], controlRenderer, footerRenderer, hasEnterKeyStopPropagation, manualCloseMode, showCurrentDate = true, onMonthChange, onDateChange, useNumberFieldForTime = false, withSeconds = false, onFocus, onBlur, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: dataSelectorId } = _a, rest = __rest(_a, ["className", "disabled", "value", "onChange", "size", "error", "withTime", "rightSectionRenderer", "is12Hours", "startDatetime", "placeholder", "endDatetime", "isDisabledDate", "onDateError", "texts", "highlightDates", "controlRenderer", "footerRenderer", "hasEnterKeyStopPropagation", "manualCloseMode", "showCurrentDate", "onMonthChange", "onDateChange", "useNumberFieldForTime", "withSeconds", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const context = (0, react_1.useContext)(DatetimeInputContext_1.DatetimeInputContext);
    const calculatedStartDate = (0, getDateWithOffset_1.getDateWithOffset)(startDatetime, context.serverUtcOffset);
    const calculatedEndDate = (0, getDateWithOffset_1.getDateWithOffset)(endDatetime, context.serverUtcOffset);
    const rootRef = (0, react_1.useRef)(null);
    const buttonRef = (0, react_1.useMemo)(() => ref || rootRef, [ref]);
    const uiTexts = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, constants_1.DEFAULT_TEXTS), texts)), [texts]);
    const { focused, active, activate, input: { onFocus: onFocusInput, onBlur: onBlurInput }, preventBlur } = (0, useControlState_1.useControlState)({
        onFocus,
        onBlur,
        rootRef: buttonRef
    });
    const defaultSize = (0, react_1.useMemo)(() => (withTime ? public_1.CONTROL_SIZE.s : public_1.CONTROL_SIZE.xs), [withTime]);
    const defaultControlRenderer = (0, react_1.useMemo)(() => (0, renderer_1.createDefaultDatetimeInputControl)(), []);
    const totalControlRenderer = (0, react_1.useMemo)(() => {
        if (controlRenderer) {
            return controlRenderer;
        }
        if (context.controlRenderer) {
            return context.controlRenderer;
        }
        return defaultControlRenderer;
    }, [context.controlRenderer, controlRenderer, defaultControlRenderer]);
    const [control] = (0, Dropdown_1.useDropdown)({
        offset: 1,
        ref: buttonRef,
        renderControl: ({ button, isActive, actions: dropdownActions }) => {
            const actions = {
                open: () => {
                    if (disabled || isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.show();
                    activate();
                },
                close: () => {
                    if (disabled || !isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.hide();
                    activate();
                }
            };
            return totalControlRenderer(Object.assign(Object.assign({}, rest), { className: (0, helpers_1.cn)('vm-DatetimeInput', className), testId: dataSelectorId, error: Boolean(error), size: size || defaultSize, disabled: Boolean(disabled), active, opened: isActive, actions,
                focused,
                value, startDatetime: calculatedStartDate, endDatetime: calculatedEndDate, hasEnterKeyStopPropagation,
                placeholder,
                onChange, onValueError: onDateError, withTime,
                withSeconds,
                is12Hours, texts: {
                    am: uiTexts.am,
                    pm: uiTexts.pm
                }, style, control: {
                    ref: button.ref,
                    onFocus: onFocusInput,
                    onBlur: onBlurInput,
                    onClick,
                    onMouseDown: (e) => {
                        e.stopPropagation();
                        actions.open();
                        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                    },
                    onMouseUp,
                    onMouseEnter,
                    onMouseLeave,
                    onKeyDown: (e) => {
                        if (e.key === ' ' && !disabled) {
                            isActive ? actions.close() : actions.open();
                        }
                        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                    },
                    onKeyUp,
                    onKeyPress
                } }));
        },
        renderContent: ({ actions }) => (react_1.default.createElement(PopoverBody, null,
            react_1.default.createElement(DatetimeSelector_1.DatetimeSelector, { onMouseDown: preventBlur, value: value, rightSectionRenderer: rightSectionRenderer, withTime: !!withTime, is12Hours: !!is12Hours, withSeconds: withSeconds, startDatetime: calculatedStartDate, endDatetime: calculatedEndDate, isDisabledDate: isDisabledDate, onRequestClose: actions.hide, onSelect: onChange, texts: uiTexts, highlightDates: highlightDates, showCurrentDate: showCurrentDate, manualCloseMode: manualCloseMode, onMonthChange: onMonthChange, onDateChange: onDateChange, footerRenderer: footerRenderer, useNumberFieldForTime: useNumberFieldForTime })))
    });
    return control;
});
//# sourceMappingURL=DatetimeInput.js.map